export default function LogoMini() {
    
    return <ion-icon name="logo-instagram"></ion-icon>
}